export default ({
  namespaced: true,
  state: {
    accessToken: null,
    userData: null
  },
  getters: {
    getAccessToken (state) {
      state.accessToken = state.accessToken || localStorage.accessToken
      return state.accessToken
    },
    getUserData (state) {
      state.userData = (localStorage.userData) || '{}'
      return JSON.parse(state.userData)
    }
  },
  mutations: {
    storeLogin (state, {accessToken = '', userData}) {
      state.userData = userData
      state.accessToken = accessToken
      localStorage.userData = userData
      localStorage.accessToken = accessToken
    },
    setUserData (state, {userData = {}}) {
      state.userData = userData
      localStorage.userData = userData
    },
    storeLogout (state) {
      state.userData = null
      state.accessToken = null
      delete localStorage.accessToken
      delete localStorage.userData
      delete localStorage.isAutoLogin
    },
  },
  actions: {
    storeLogout ({commit}) {
      commit('storeLogout')
      location.reload()
    }
  }
})
